<template>
  <section class="product-list">
    <div
      v-for="product in products"
      v-show="isThisProductVisible(product)"
      :key="product.sku"
      :style="
          qualifications[product.sku] &&
          qualifications[product.sku].addOns &&
          !qualifications[product.sku].addOns.errorMessage &&
          Object.keys(qualifications[product.sku].addOns).length < 1
        ?
          { 'min-height': '500px'}
        :
          {}"
      class="product"
    >
    <ProductCard
      :product="product"
      :qualifications="qualifications"
      :tdc="tdc"
    />
    </div>
    <div
      class="not-qualified"
      v-show="!qualifiedProducts && !productsInDifferentCountry && totalCountriesWithQuantity < 1"
    >
      <div v-if="qualificationLoadError">
        <h2>{{ tdc.tdc_loadQualificationsError }}</h2>
      </div>
      <div v-else>
        <h2>{{ tdc.tdc_noItemsTitle }}</h2>
        <p>{{ tdc.tdc_noItemsText }}</p>
      </div>
      <button @click="$emit('goToHome')" class="primary-outline">
        {{ tdc.tdc_backToHome }}
      </button>
    </div>
  </section>
</template>

<script>
import ProductCard from './ProductCard.vue'

export default {
  components: {
    ProductCard,
  },
  props: {
    products: Array,
    productsInDifferentCountry: Boolean,
    qualificationLoadError: Boolean,
    qualifications: Array,
    qualifiedProducts: Array,
    tdc: Object,
    totalCountriesWithQuantity: Number
  },
  methods: {
    isThisProductVisible(product) {
      const qualification = this.qualifications[product.sku]
      let result = false
      if (this.qualifiedProducts && qualification) {
        const isAddOn = qualification.isAddOn
        const addOnQuantities = this.getQualificationAddOnQuantity(product)
        result = !isAddOn && (addOnQuantities > 0 || qualification.quantity > 0)
      }
      return result
    },
    getQualificationAddOnQuantity(product) {
      const qualification = this.qualifications[product.sku]
      const hasAddons = qualification.addOns && Object.keys(qualification.addOns).length > 0
      let addOnQuantities = 0
      if (hasAddons) {
        Object.values(qualification.addOns).forEach(addOn => {
          addOnQuantities += addOn.quantity
        })
      }
      return addOnQuantities
    },
  }
}
</script>

<style lang="scss">
.product-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.product-list > div {
  width: 355px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  margin: 20px;
  box-sizing: border-box;
  justify-content: space-between;
}

.product-list > div ns-product-basic {
  width: 100%;
}

.product-list > div button {
  margin-bottom: 15px;
  width: 100%;
}

.product-list .variant-container {
  margin-bottom: 15px;
}

.product-list .variant-container .shade {
  border-radius: 50%;
  height: 20px;
  margin-right: 10px;
  width: 20px;
}

.product-list > div ns-quantity-selector {
  width: auto;
  margin-bottom: 10px;
}

.product-list > div .ns-select + strong {
  font-size: 18px;
  color: var(--blackhole);
  padding-left: 8px;
}

.product-list .product {
  background: white;
  padding: 20px 30px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.product-list > div > div {
  text-align: center;
}

.product-list .available-qty {
  font-size: 20px;
  font-weight: var(--font-weight-bold);
  color: var(--blackhole);
}

.product-list .num-available {
  position: relative;
  display: inline-block;
}

.product-list .num-available .middle-block {
  background-color: var(--magic);
  color: white;
  height: 36px;
  position: relative;
  z-index: 2;
  margin-right: 20px;
  font-size: 22px;
  font-weight: var(--font-weight-bold);
  display: flex;
  align-items: center;
  border-radius: 10px;
}

.product-list .num-available .before-block {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--magic);
  position: absolute;
  left: -10px;
  top: 0;
}

.product-list .num-available .after-block {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--magic);
  position: absolute;
  right: 10px;
  top: 0;
}

.not-qualified h2 {
  font-size: 22px;
  line-height: 27px;
  margin-bottom: 5px;
  font-weight: var(--font-weight-bold);
  font-family: var(--font-family-primary);
}

.not-qualified {
  text-align: center;
}

.not-qualified h2,
.not-qualified p {
  color: white;
  max-width: 260px;
  margin: 0 auto 20px;
}

.not-qualified button {
  background: white;
  max-width: 260px;
  margin: auto;
}

.not-qualified button:hover {
  background: rgba(255, 255, 255, 0.75);
}

@media (max-width: 450px) {
  .product-list > div {
    margin: 10px 40px;
  }

  .product-list .product {
    padding: 20px;
  }
}

@media (max-width: 320px) {
  .product-list > div {
    margin: 10px 20px;
  }
}
</style>
